import React, { useState, useRef, useEffect } from "react";
import { CiImport, CiRead } from "react-icons/ci";
import { toast } from "react-toastify";
import { ComponentInfo } from "../../styled";
import { Button, Modal, Upload, Radio, Flex } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { UploadDocumentoClientContextProps, uploadDocumentoProps } from "../../../../../../../service/uploadService";
import { ServiceDownloadDocumento, ServiceDownloadDocumentoContexto } from "../../../../../../../service/downloadService";
import { POST_Remove_arquivo } from "../../../../../../../service/api";

import ModalUpload from "./Update";
import TabelaContextDoc from "./Tabelas/TabelaDocsContext";
import TabelaDocOSObrigatorio from "./Tabelas/TabelaDocOSObrigatorio";
import TabelaOutrosDocs from "./Tabelas/TabelaOutrosDoc";
import { Pagination, Stack } from "@mui/material";
import TabelaTodosDocs from "./Tabelas/TableTodosDocs";
import JsonViewer from "./JsonDetails";
import { TbFileImport } from "react-icons/tb";

import styles from "./documento.module.css"

export function GroupDocumentos({
  numeroSolicitacao,
  fetchData,
  setObjDocs,
  objDocs,
  info,
  dados,
  fetchListDocumento,
  docsContexto,
  filesContexto,
  fetchListDocumentoContexto,
  loadingDocsContext,
  setDocsContexto,

  setMudancaUF,
  setMudancaMunicipio,
  setEnderecoAntesDaMudancaUF,
  setImAntesDaMudanca,
}) {

  const [isModalAdicionarDoc, setIsModalAdicionarDoc] = useState(false);
  const [isModalAdicionarDocClienteContext, setIsModalAdicionarDocClienteContext] = useState(false);
  const [isModalLerArquivoJSON, setIsModalLerArquivoJSON] = useState(false);
  const [loadingConfirmOk, setLoadingConfirmOk] = useState(false);
  const [loadingConfirmExclusaoArquivo, setLoadingConfirmExclusaoArquivo] =
    useState(false);
  const [loadings, setLoadings] = useState([]);
  const [loadingDocumentos, setLoadingDocumentos] = useState(false);
  const [loadingCertificado, setLoadingCertificado] = useState(false);
  const [documentos, setDocumentos] = useState([]);

  const [isModalConfirmeRemove, setIsModalConfirmeRemove] = useState(false);
  const [isModalConfirmeRemoveArquivo, setIsModalConfirmeRemoveArquivo] =
    useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // Arquivo selecionado para remoção
  const [selectedAquivo, setSelectedAquivo] = useState(null);
  const [page, setPage] = useState(1);
  const [pageArq, setArqPage] = useState(1);
  const [pageArqContext, setpageArqContext] = useState(1);

  const [arquivos, setArquivos] = useState([]);

  const itemsPerPage = 5;
  const arqPerPage = 5;
  const arqPerPageContext = 5;

  const [arquivosAtualizados, setArquivosAtualizados] = useState(false);

  const [jsonData, setJsonData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("imports");

  const startIndex = (pageArqContext - 1) * arqPerPageContext;
  const endIndex = startIndex + arqPerPageContext;
  const docsPaginados = (docsContexto || []).slice(startIndex, endIndex);



  const arquivosObrigatorios = [
    "Desenquadramento-mei",
    "Viabilidade-prefeitura",
    "FCPJ-RedeSim",
    "Procuracao-ECAC",
    "Termo-de-regime-tributario",
    "Inscricao-estadual",
    "inscricao-municipal",

    "CNPJ",
    "Ficha-Cadastral-Nacional",
  ];

  // Função para buscar os documentos
  const loadDocumentos = async () => {
    try {
      const docs = await fetchListDocumento(numeroSolicitacao);
      setDocumentos(docs);
    } catch (error) {
      toast.error("Erro ao carregar documentos.");
    }
  };

  // Configuração do upload com callback para atualizar os documentos
  const uploadDoc = uploadDocumentoProps(
    numeroSolicitacao,
    "/ordem-servico/documento/upload",
    loadDocumentos // Atualiza os documentos ao concluir o upload
  );

  const atualizarListContext = async () => {
    await fetchListDocumentoContexto();
    setIsModalAdicionarDocClienteContext()
  }

  // upload e atualização dos docs do cliente context
  const uploadDocClienteContext = UploadDocumentoClientContextProps(
    null,
    "/upload",
    atualizarListContext
  );

  //////////////////////////////////////////////////////////////////////////////////////

  // Função para excluir documentos
  const removerDocumento = async (filePath) => {
    setLoadingDocumentos(true);
    try {
      const url = `/ordem-servico/documento/remover`;
      // Normaliza as barras antes de enviar
      const normalizedPath = filePath.replace(/\\\\/g, "\\");

      // Converte o JSON corretamente sem duplicar barras
      const data = JSON.parse(
        JSON.stringify({ id: numeroSolicitacao, files: [normalizedPath] })
      );

      await POST_Remove_arquivo(url, data);

      await fetchData();
      await fetchListDocumento();
    } catch (error) {
      toast.error(`Erro: ${error.message}`);
      console.error(error.message);
    } finally {
      setLoadingDocumentos(false);
    }
  };

  const showModal = async (filePath) => {
    setSelectedFile(filePath);
    setIsModalConfirmeRemove(true);
    await fetchListDocumentoContexto();
  };

  const showModalExcluirArquivo = (filePath) => {
    setSelectedAquivo(filePath.caminho);
    setIsModalConfirmeRemoveArquivo(true);
  };

  const excluirArquivos = async () => {
    setLoadingConfirmExclusaoArquivo(true);

    try {
      if (selectedAquivo !== null) {
        await removerDocumento(selectedAquivo);

        setObjDocs((prevDocs) =>
          prevDocs.filter((file) => file !== selectedAquivo)
        );
      }

      setIsModalConfirmeRemove(false);
    } catch (error) {
      console.error("Erro ao remover documento:", error);
    } finally {
      setLoadingConfirmExclusaoArquivo(false);
    }
  };

  const handleOk = async () => {
    setLoadingConfirmOk(true); // Ativa o loading

    try {
      if (selectedFile !== null) {
        await removerDocumento(selectedFile); // Chama a função assíncrona
        setObjDocs((prevDocs) =>
          prevDocs.filter((file) => file !== selectedFile)
        );
      }
      setIsModalConfirmeRemove(false); // Fecha o modal
    } catch (error) {
      console.error("Erro ao remover documento:", error);
    } finally {
      setLoadingConfirmOk(false); // Desativa o loading
    }
  };

  const downloadDocumento = async (id, filename) => {
    setLoadingCertificado(true);

    try {
      await ServiceDownloadDocumento(id, filename);
    } catch (error) {
      toast.error("Erro ao baixar o documento.");
    } finally {
      setLoadingCertificado(false);
    }
  };

  const FloatButtonDownload = () => {
    return (
      <div className="float-button">
        <div className="button">
          <DownloadOutlined />
        </div>
      </div>
    );
  };

  const FloatButtonDelete = () => {
    return (
      <div className="float-button">
        <div className="button">
          <DeleteOutlined />
        </div>
      </div>
    );
  };

  const FloatButtonVisualizar = () => {
    return (
      <div className="float-button">
        <div className="button">
          <CiRead />
        </div>
      </div>
    );
  };

  const handleChangeContext = (event, value) => {
    setpageArqContext(value);
  };

  const handleChangeArquivos = (event, value) => {
    setArqPage(value);
  };

  // Filtrar os dados para exibir apenas os itens da página atual
  const filteredData = (objDocs || []).filter((filePath) => {
    const fileNameWithExt = filePath.split(/[/\\]/).pop(); // nome.extensao
    const fileNameWithoutExt = fileNameWithExt.replace(/\.[^/.]+$/, ""); // remove a extensão

    return arquivosObrigatorios.includes(fileNameWithoutExt);
  });


  const paginatedData = filteredData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  useEffect(() => {
    if (!arquivosAtualizados) {
      const arquivosCompletos = (objDocs || []).map((filePath) => ({
        nome: filePath.split(/[/\\]/).pop(),
        caminho: filePath,
      }));

      const arquivosNaoObrigatorios = arquivosCompletos.filter((arquivo) => {
        const nomeSemExtensao = arquivo.nome
          .split(".")
          .slice(0, -1)
          .join(".")
          .toLowerCase();
        return !arquivosObrigatorios
          .map((n) => n.toLowerCase())
          .includes(nomeSemExtensao);
      });

      setArquivos(arquivosNaoObrigatorios);
      setArquivosAtualizados(true);
    }
  }, [objDocs, arquivosObrigatorios, arquivosAtualizados]);

  const paginationArquivosNaoObrigatorios = arquivos.slice(
    (pageArq - 1) * arqPerPage,
    pageArq * arqPerPage
  );

  const handleVisualizarArquivo = async (file) => {
    if (!file.nome.toLowerCase().endsWith(".json")) {
      toast.info("Só é possível visualizar arquivos JSON.");
      return;
    }

    try {
      const url = `/portal/rest/contador/ordem-servico/documento/download?id=${info.id
        }&filename=${encodeURIComponent(file.nome)}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Erro ao carregar o arquivo.");
      }

      const json = await response.json();
      setJsonData(json);
      setIsModalLerArquivoJSON(true);
      console.log("Visualizando arquivo json: ", json);
    } catch (error) {
      console.error("Erro ao abrir o JSON:", error);
      alert("Não foi possível abrir o arquivo JSON.");
    }
  };

  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
  };

  return (
    <>
      <ComponentInfo>
        <Flex vertical gap="middle">
          <div style={{ textAlign: "center" }}>
            <Radio.Group value={selectedOption} onChange={handleRadioChange}>
              <Radio.Button value="imports">
                Documentos importados OS
              </Radio.Button>
              <Radio.Button value="docsCliente">
                Documentos do cliente
              </Radio.Button>
              <Radio.Button value="allDocs">
                Histórico de documentos
              </Radio.Button>
            </Radio.Group>
          </div>

          {selectedOption === "docsCliente" && (
            <>
              <div className="btn-Add">
                <div style={{ display: "flex" }}>
                  <div className="titulo position-left-12">Documentos Disponibilizados ao Cliente</div>
                  <div style={{width: "100%"}}>
                    <button
                      
                      onClick={() => setIsModalAdicionarDocClienteContext(true)}
                      className={styles.btnCliente}
                    >
                      <TbFileImport /> Importar arquivos para o cliente
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <TabelaContextDoc
                  dados={dados}
                  docsContexto={docsPaginados}
                  onDownload={ServiceDownloadDocumentoContexto}
                  FloatButtonDownload={FloatButtonDownload}
                  FloatButtonDelete={FloatButtonDelete}
                  arqPerPageContext={arqPerPageContext}
                  pageArqContext={pageArqContext}
                  setpageArqContext={setpageArqContext}
                  loadingDocsContext={loadingDocsContext}
                  setDocsContexto={setDocsContexto}
                  fetchData={fetchData}


                  setMudancaUF={setMudancaUF}
    setMudancaMunicipio={setMudancaMunicipio}
    setEnderecoAntesDaMudancaUF={setEnderecoAntesDaMudancaUF}
    setImAntesDaMudanca={setImAntesDaMudanca}

                  
                />

                {Array.isArray(docsContexto) && docsContexto.length > 0 && (
                  <Stack
                    spacing={2}
                    style={{ alignItems: "center", marginTop: 20 }}
                  >
                    <Pagination
                      count={Math.ceil(docsContexto.length / arqPerPageContext)}
                      page={pageArqContext}
                      onChange={handleChangeContext}
                    />
                  </Stack>
                )}

              </div>
            </>
          )}

          {selectedOption === "allDocs" && (
            <TabelaTodosDocs
              loadingDocsContext={loadingDocsContext}
              filesContexto={filesContexto}
            />
          )}

          {selectedOption === "imports" && (
            <>
              <div className="DisplayFlex">
                <div className="titulo">
                  <span>Arquivos obrigatórios</span>
                </div>
                <div className="btn-Add">
                  <div style={{ display: "flex" }}>
                    <div className="titulo position-left-12">
                      Outros arquivos
                    </div>
                    <div>
                      <Button
                        type="primary"
                        onClick={() => setIsModalAdicionarDoc(true)}
                        className="color"
                      >
                        <CiImport /> Importar outros arquivos na OS
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <TabelaDocOSObrigatorio
                    loadingDocumentos={loadingDocumentos}
                    paginatedData={paginatedData}
                    loadings={loadings}
                    info={info}
                    FloatButtonVisualizar={FloatButtonVisualizar}
                    FloatButtonDownload={FloatButtonDownload}
                    FloatButtonDelete={FloatButtonDelete}
                    handleVisualizarArquivo={handleVisualizarArquivo}
                    downloadDocumento={downloadDocumento}
                    showModal={showModal}
                    dados={dados}
                  />

                  <Stack spacing={2} style={{ alignItems: "center" }}>
                    <Pagination
                      count={Math.ceil(filteredData.length / itemsPerPage)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                    />
                  </Stack>
                </div>

                <div style={{ width: "100%" }}>
                  <TabelaOutrosDocs
                    loadingDocumentos={loadingDocumentos}
                    paginationArquivosNaoObrigatorios={
                      paginationArquivosNaoObrigatorios
                    }
                    loadings={loadings}
                    info={info}
                    FloatButtonVisualizar={FloatButtonVisualizar}
                    FloatButtonDownload={FloatButtonDownload}
                    FloatButtonDelete={FloatButtonDelete}
                    handleVisualizarArquivo={handleVisualizarArquivo}
                    downloadDocumento={downloadDocumento}
                    showModalExcluirArquivo={showModalExcluirArquivo}
                    handleChangeArquivos={handleChangeArquivos}
                  />

                  <Stack spacing={2} style={{ alignItems: "center" }}>
                    <Pagination
                      count={Math.ceil(arquivos.length / arqPerPage)}
                      page={pageArq}
                      onChange={handleChangeArquivos}
                    />
                  </Stack>
                </div>
              </div>

              {/* Modal de confirmação */}
              <div>
                <Modal
                  title="Confirmar Remoção"
                  visible={isModalConfirmeRemove}
                  onOk={handleOk}
                  confirmLoading={loadingConfirmOk}
                  onCancel={() => setIsModalConfirmeRemove(false)}
                  okText="Sim, remover"
                  cancelText="Cancelar"
                >
                  <p>Tem certeza que deseja remover este documento?</p>
                </Modal>
              </div>

              <div>
                <Modal
                  title="Confirmar Remoção"
                  visible={isModalConfirmeRemoveArquivo}
                  onOk={excluirArquivos}
                  confirmLoading={loadingConfirmExclusaoArquivo}
                  onCancel={() => setIsModalConfirmeRemoveArquivo(false)}
                  okText="Sim, remover"
                  cancelText="Cancelar"
                >
                  <p>Tem certeza que deseja remover este documento?</p>
                </Modal>
              </div>
            </>
          )}

        </Flex>
      </ComponentInfo>


      <Modal title="Carregar documentos para ordem de serviço atual" open={isModalAdicionarDoc} onCancel={() => setIsModalAdicionarDoc(false)} footer={<Button onClick={() => setIsModalAdicionarDoc(false)}>Fechar</Button>}>
        <ModalUpload
          onClose={() => setIsModalAdicionarDoc(false)}
          uploadProps={uploadDoc}
        />
      </Modal>

      <Modal title="Carregar documentos do cliente" open={isModalAdicionarDocClienteContext} onCancel={() => setIsModalAdicionarDocClienteContext(false)} footer={<Button onClick={() => setIsModalAdicionarDocClienteContext(false)}>Fechar</Button>}>
        <ModalUpload
          onClose={() => setIsModalAdicionarDocClienteContext(false)}
          uploadProps={uploadDocClienteContext}
        />
      </Modal>

      <Modal open={isModalLerArquivoJSON} title="Leitura do Arquivo JSON" onCancel={() => setIsModalLerArquivoJSON(false)} footer={null}>
        {jsonData ? (
          <JsonViewer data={jsonData} />
        ) : (
          <span>Carregando dados...</span>
        )}

      </Modal>
    </>
  );
}

export default GroupDocumentos;
